export const Regex = {
  // 邮箱
  email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,

//   // 手机号（中国）
//   PHONE: /^1[3-9]\d{9}$/,

//   // 固定电话
//   TEL: /^0\d{2,3}-?\d{7,8}$/,

//   // 身份证（中国18位）
//   ID_CARD: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])([0-2][1-9]|3[01])\d{3}[\dXx]$/,

//   // 密码：6-20位，字母+数字
//   PASSWORD: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,

//   // URL
//   URL: /^https?:\/\/[^\s/$.?#].[^\s]*$/,

//   // 中文名
//   CHINESE_NAME: /^[\u4e00-\u9fa5]{2,20}$/,

//   // 统一社会信用代码（18位）
//   CREDIT_CODE: /^[0-9A-Z]{18}$/,

//   // 纯数字
//   NUMBER: /^\d+$/,

//   // 空白字符（用于 trim 检测）
//   WHITESPACE: /^\s+|\s+$/g,
};